import { StatCardProps } from "../components/StatCard";

export const data = [
  {
    id: "burger",
    color: "#42a5f5",
    data: [
      { x: "Jul", y: 200 },
      { x: "Aug", y: 360 },
      { x: "Sept", y: 180 },
      { x: "Oct", y: 50 },
      { x: "Nov", y: 240 },
      { x: "Dec", y: 160 },
    ],
  },
  {
    id: "donet",
    color: "#32CD32",
    //color: "#908C9B",
    data: [
      { x: "Jul", y: 100 },
      { x: "Aug", y: 250 },
      { x: "Sept", y: 90 },
      { x: "Oct", y: 230 },
      { x: "Nov", y: 140 },
      { x: "Dec", y: 80 },
    ],
  },
];

export const data2: StatCardProps[] = [
  {
    icon: "Visibility",
    value: "14k",
    interval: "Last 30 days",
    trend: "up",
  },
  {
    icon: "Group",
    value: "325",
    interval: "Last 30 days",
    trend: "down",
  },
  {
    icon: "LocalMall",
    value: "200k",
    interval: "Last 30 days",
    trend: "neutral",
  },
  {
    icon: "Storefront",
    value: "250k",
    interval: "Last 30 days",
    trend: "up",
  },
];
